import './popupGlobal.less';
import { useTranslation } from 'react-i18next';
import { useContext, useEffect, useRef, useState } from 'react';
import { EditContext } from '@/context/EditContext.jsx';
import { infoController } from '@/api/index.js';
import { EseClosePopup } from '@/hooks/useClosePopup.jsx';
import watermark_sign from '@/assets/edit/watermark_sign.gif';
import close from '@/assets/edit/close.png';

export default function PopUpGlobal() {
  return (
    <div className="edit_popup">
      {/*水印支付弹窗*/}
      <WatermarkPayPop />
      <ExportPayPop />
    </div>
  );
}
function WatermarkPayPop() {
  const { t } = useTranslation();
  const PopUpRef = useRef();
  const { watermarkPayPop, setWatermarkPayPop } = useContext(EditContext);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (watermarkPayPop) {
      PopUpRef.current.show();
    } else {
      PopUpRef.current?.close();
    }
  }, [watermarkPayPop]);
  const closePop = () => {
    setWatermarkPayPop(false);
  };
  const pay = async () => {
    if (loading) return;
    setLoading(true);
    try {
      const plans = await infoController.infoPlans();
      const priceId = plans.data.find((res) => res.level === 'Starter').monthlyPriceId;
      const data = { type: 0, priceId, subscriptionPeriod: 0 };
      const res = await infoController.checkout(data);
      window.open(res.data, '_blank');
    } catch (e) {
      console.log(e);
    }
    setLoading(false);
  };
  return (
    <dialog ref={PopUpRef} className="modal">
      <EseClosePopup close={closePop} />

      <div className="watermarkPay">
        <div className="watermarkPay_left">
          <img src={watermark_sign} />
        </div>
        <div className="watermarkPay_right">
          <img src={close} alt="" className="close" onClick={closePop} />
          <h1 className="title">{t('As_Edit_MarkFreeTitle')}</h1>
          <p className="desc">{t('As_Edit_MarkFreeDesc')}</p>
          <p className="price">{t('As_Edit_MarkFreePricing')}</p>
          <div className="line"></div>
          <p className="watermark_tip">{t('As_Edit_MarkFreePlus')}</p>
          <ul>
            {[
              'As_Edit_MarkFreeBene1',
              'As_Edit_MarkFreeBene2',
              'As_Edit_MarkFreeBene3',
              'As_Edit_MarkFreeBene4',
            ].map((item, index) => (
              <li key={index}>
                <div className="dot"></div>
                {t(item)}
              </li>
            ))}
          </ul>
          <button className="btn btn-active btn-primary pay exportPayBtn" onClick={pay}>
            {loading && <span className="loading loading-spinner"></span>}
            {t('As_Edit_Upgrade')}
          </button>
        </div>
      </div>
    </dialog>
  );
}
function ExportPayPop() {
  const { t } = useTranslation();
  const PopUpRef = useRef();
  const { exportPayPop, setExportPayPop } = useContext(EditContext);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (exportPayPop) {
      PopUpRef.current.show();
    } else {
      PopUpRef.current?.close();
    }
  }, [exportPayPop]);
  const closePop = () => {
    setExportPayPop(false);
  };
  const pay = async () => {
    if (loading) return;
    setLoading(true);
    try {
      const plans = await infoController.infoPlans();
      const priceId = plans.data.find((res) => res.level === 'Starter').monthlyPriceId;
      const data = { type: 0, priceId, subscriptionPeriod: 0 };
      const res = await infoController.checkout(data);
      window.open(res.data, '_blank');
    } catch (e) {
      console.log(e);
    }
    setLoading(false);
  };
  return (
    <dialog ref={PopUpRef} className="modal">
      <EseClosePopup close={closePop} />

      <div className="watermarkPay">
        <div className="watermarkPay_left">
          <img src={watermark_sign} />
        </div>
        <div className="watermarkPay_right">
          <img src={close} alt="" className="close" onClick={closePop} />
          <h1 className="title">{t('As_Edit_ExportTitle334')}</h1>
          <p className="desc">{t('As_Edit_MarkFreeDesc')}</p>
          <p className="price">{t('As_Edit_MarkFreePricing')}</p>
          <div className="line"></div>
          <p className="watermark_tip">{t('As_Edit_MarkFreePlus')}</p>
          <ul>
            {[
              'As_Edit_MarkFreeBene1',
              'As_Edit_MarkFreeBene2',
              'As_Edit_MarkFreeBene3',
              'As_Edit_MarkFreeBene4',
            ].map((item, index) => (
              <li key={index}>
                <div className="dot"></div>
                {t(item)}
              </li>
            ))}
          </ul>
          <button className="btn btn-active btn-primary pay exportPayBtn" onClick={pay}>
            {loading && <span className="loading loading-spinner"></span>}
            {t('As_Edit_ExportUpgrade334')}
          </button>
        </div>
      </div>
    </dialog>
  );
}
